var alignment_default = {
  "alignLeft": "-ubBW",
  "textWrapNowrap": "-Wtzt",
  "alignRight": "y5Tjj",
  "alignCenter": "G6msk",
  "sizeFullWidth": "_2mRFR",
  "renderedInTable": "MgFJ3",
  "sizeOriginal": "rom81",
  "sizeContent": "kTZMg",
  "sizeSmall": "uX1DU",
  "sizeSmallCenter": "lXxUk",
  "flex": "MgW5G",
  "LEFT": "MmO7-",
  "CENTER": "txOYg",
  "RIGHT": "Aep1p",
  "AUTO": "_1XZfu",
  "JUSTIFY": "uBQlL"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
